import { __assign, __spreadArrays } from "tslib";
import moment from "moment";
import { ReportFilterOperationType, } from "peekdata-datagateway-api-sdk";
import { dateTime } from "../../constants/dateTime";
import { FilterOptionTypes, FilterTypes, IFilter, } from "../../models/filter";
import { IAction } from "../action";
import { actionTypes, IChangeFilterInput, ISelectFilter, } from "../actions";
var initialState = [];
export function filters(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.dimensionsLoaded:
        case actionTypes.dataModelNamesLoaded:
            return initialState;
        case actionTypes.filtersLoaded:
            var requestFilters = action.payload;
            var dateRanges = [];
            var singleKeys = [];
            var singleValues = [];
            if (requestFilters) {
                if (requestFilters.dateRanges) {
                    dateRanges = getDateRanges(requestFilters.dateRanges);
                }
                if (requestFilters.singleKeys) {
                    singleKeys = getSingleKeys(requestFilters.singleKeys);
                }
                if (requestFilters.singleValues) {
                    singleValues = getSingleValues(requestFilters.singleValues);
                }
            }
            return __spreadArrays(dateRanges, singleKeys, singleValues);
        case actionTypes.addFilter:
            return __spreadArrays(state, [{}]);
        case actionTypes.removeFilter:
            return state.filter(function (f) { return f !== action.payload; });
        case actionTypes.changeFilterInput:
            return state.map(function (f) {
                var _a;
                var _b = action.payload, filter = _b.filter, name = _b.name, value = _b.value;
                if (filter !== f) {
                    return f;
                }
                return __assign(__assign({}, f), (_a = {}, _a[name] = value, _a));
            });
        case actionTypes.selectFilterOption:
            return getProcessedFilters(state, action.payload);
        case actionTypes.setFilters:
            return action.payload;
        default:
            return state;
    }
}
var getProcessedFilters = function (state, payload) {
    return state.map(function (f) {
        var filter = payload.filter, selectedItem = payload.selectedItem, optionType = payload.optionType;
        if (f !== filter) {
            return f;
        }
        switch (optionType) {
            case FilterOptionTypes.Key:
                if (typeof selectedItem === "string") {
                    return __assign(__assign({}, f), { key: selectedItem });
                }
                return __assign(__assign({}, f), { keys: selectedItem });
            case FilterOptionTypes.FilterType:
                var newFilter = {
                    filterType: selectedItem,
                };
                if (selectedItem === FilterTypes.SingleValues) {
                    newFilter.keys = f.keys || [];
                }
                else {
                    newFilter.key = f.key || null;
                }
                if (selectedItem === FilterTypes.DateRanges) {
                    newFilter.from = moment()
                        .subtract(3, "months")
                        .format(dateTime.dateFormat);
                    newFilter.to = moment().format(dateTime.dateFormat);
                }
                return newFilter;
            case FilterOptionTypes.Operation:
                return __assign(__assign({}, f), { operation: selectedItem });
            default:
                return f;
        }
    });
};
var getDateRanges = function (dateRanges) {
    return dateRanges.map(function (dr) { return ({
        filterType: FilterTypes.DateRanges,
        key: dr.key,
        from: dr.from,
        to: dr.to,
    }); });
};
var getSingleKeys = function (singleKeys) {
    return singleKeys.map(function (sk) { return ({
        filterType: FilterTypes.SingleKeys,
        key: sk.key,
        operation: sk.operation || ReportFilterOperationType.EQUALS,
        values: sk.values.join(";"),
    }); });
};
var getSingleValues = function (singleValues) {
    return singleValues.map(function (sv) { return ({
        filterType: FilterTypes.SingleValues,
        keys: sv.keys,
        operation: sv.operation || ReportFilterOperationType.EQUALS,
        value: sv.value,
    }); });
};
